import { A, F, pipe } from '@mobily/ts-belt';
import { FilterQueryParam, SearchParams } from './hooks/useSearchParams';
export const insertElement = (arr: React.ReactElement[], newItem: React.ReactElement, index: number) => [...arr.slice(0, index), newItem, ...arr.slice(index)];

/**
 * Apollo uses the query variables for its cache IDs.
 * The order of the variables is persisted in the cache ID,
 * which can lead to unnecessary duplicate data in the cache
 * when two queries use the same variables but in different order.
 *
 * Using `localeCompare` to sort values in ascending order:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/localeCompare#sort_an_array
 */
const formatFilter = (filterId: FilterQueryParam, values: string[]) => pipe(values, A.sort((a, b) => a.localeCompare(b)), A.map(value => ({
  id: filterId,
  value
})), F.toMutable);

/**
 * Formats the provided lists of selected `color` and `occasion` filters to be used
 * as the `filters` variable when querying the `shopContent.search` GraphQL field.
 */
export const formatFiltersVariable = ({
  color = [],
  occasion = []
}: Pick<SearchParams, 'color' | 'occasion'>) => {
  const colorFilter = formatFilter('color', color);
  const occasionFilter = formatFilter('occasion', occasion);
  const filters = colorFilter.concat(occasionFilter);
  return A.isNotEmpty(filters) ? filters : undefined;
};